import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStaffDetailData, IGetStaffDetailVars } from '../types';

export const GET_STAFF_DETAIL: TypedDocumentNode<IGetStaffDetailData, IGetStaffDetailVars> = gql`
  query getStaffDetail($input: ReadUserInput!) {
    readUser(input: $input) {
      id
      firstName
      lastName
      username
      email
      phone
      role
      active
      confirmed
      room {
        id
        title
      }
      welcomed
    }
  }
`;
